import { useEffect, useState } from 'react';

/**
 * Viewport height, updated on resize — but only for changes worth rebuilding the layout over.
 *
 * Mobile browsers grow and shrink the viewport by ~60px as the address bar hides and reveals
 * during scroll. Reacting to that would rebuild every spread mid-scroll, so small changes are
 * ignored and orientation changes are not.
 */
const SIGNIFICANT_CHANGE_PX = 90;

export function useViewportHeight(): number {
  const [height, setHeight] = useState(() =>
    typeof window === 'undefined' ? 900 : window.innerHeight
  );

  useEffect(() => {
    const onResize = () => {
      setHeight((current) =>
        Math.abs(window.innerHeight - current) >= SIGNIFICANT_CHANGE_PX ? window.innerHeight : current
      );
    };
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  return height;
}
